import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=a1913cc8&"
import script from "./UserIndex.vue?vue&type=script&lang=js&"
export * from "./UserIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports